// Hand-maintained exceptions for the Verb Conjugation page
// (src/components/ConjugationPage). The page lists every vocabulary entry that
// carries a JMdict verb class (public/vocab-data/n1-n5.json, the verbType
// field) and conjugates it with verbConjugation.ts. An entry tagged as a verb that
// cannot be conjugated correctly by those rules is left off the page by JMdict entry
// id (stable across data rebuilds). A test checks every id here is still a
// verb-tagged entry in the vocabulary data, so the list cannot silently rot. The
// vocabulary files are built by scripts/build-vocabulary-data.mjs and never edited by
// hand: they also feed the offline packs, whose hashes are regenerated at deploy.
// Empty since the NIH-281 rebuild (2026-10-15). It held one entry, 為 (id 2219050), the
// classical サ変 verb (vs-c) read す, which the engine would conjugate as 為する / すする;
// the rebuilt data no longer has it (the modern verb 為る (する) has its own card). The
// mechanism stays for the next entry that is tagged as a verb but cannot be conjugated
// correctly: add its id and a reason here.
export const EXCLUDED_VERB_IDS: ReadonlyMap<string, string> = new Map<string, string>();

// What the Verb Conjugation page lists: a verb-tagged entry that is not on the
// exclusion list. VERB_TOTAL (verbTotal.ts, the Home page's conjugation ring)
// is the size of this same set.
export function isConjugationPageVerb(word: { id: string; verbType?: string | null }): boolean {
    return Boolean(word.verbType) && !EXCLUDED_VERB_IDS.has(word.id);
}
